<template>
   <header>
      <div class="head-left">
        <a class="logo"><img src="../images/songshuAI_logo.png" alt="logo"/></a>
      </div>
      <div class="user-wrap">
        <span><i class="icon icon-user_name"></i>{{userName}}</span>
        <!-- <span id="logOut" @click.stop="logOut"><i class="icon icon-out"></i>退出</span> -->
      </div>
    </header>
</template>

<script>
/* eslint-disable */
import { getSign } from '@/pages/dl-web/utils/verify';
import api from '@/pages/dl-web/api/api';
// import { log } from '@/utils/log';
export default {
  data() {
    return {
      userName:localStorage.getItem('real_name') || this.$route.query.userName
    }
  },
  created(){
    console.log(this.$route.query.userName)
    if(this.$route.query.userName){
      this.userName = this.$route.query.userName
    }
  },
  methods: {
    // 退出登录
     logOut: async function (){
      let that = this
      let params = {
        time_stamp: (new Date()).getTime()
      }
      params.sign = getSign(params)
      let res =  await api.logOut(params)
      if(res){
        if(res.code == 0){
          this.$toast('成功退出')
          this.clearUserInfo() // 清空用户信息
          setTimeout(function () {
            that.$router.push('/dl-web/login')
          },1500)
        }else{
          this.$toast(res.msg)
        }
      }
    },
    clearUserInfo: function () {
      localStorage.clear()
      sessionStorage.removeItem('channel')
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  z-index: 999;
  top: 0;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  justify-content: space-between;
  min-width: 780px;
  padding: 14px 40px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  font-size: 14px;
  .head-left {
    display: flex;
    .logo img {
      width: 200px;
    }
    .test-title {
      position: relative;
      margin-left: 15px;
      padding-left: 15px;
      h4 {
        line-height: 24px;
        font-family: PingFangSC-Medium;
        font-weight: normal;
        i {
          font-style: normal;
          font-size: 30px;
          line-height: 5px;
          vertical-align: top;
          margin: 3px;
        }
      }
      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(153, 153, 153, 0.85);
        line-height: 12px;
      }
    }
    .test-title:before {
      position: absolute;
      content: "";
      left: 0;
      top: 6px;
      width: 1px;
      height: 24px;
      background: #ccc;
    }
  }
  .user-wrap {
    display: flex;
    align-items: center;
    #logOut {
      cursor: pointer;
    }
    span {
      margin-left: 24px;
    }
    .icon {
      vertical-align: middle;
      margin-right: 8px;
      font-size: 20px;
    }
    img {
      vertical-align: middle;
      width: 16px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
</style>
